<div mat-dialog-content>    
    <app-addedit-market [marketData]="data" (onFormSubmit)="onFormSubmit($event)" ></app-addedit-market>
</div>
<div mat-dialog-actions align="end">   
</div>